import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../../filter/FilterButton'

const FilterButtonPeriodicalReport = () => {
  const open = useSelector(state => state?.filter?.periodicalReport?.open || false)

  return (
    <>
      <FilterButton 
        module='periodicalReport'
        keysFilter={['periodId']}
      />
      { open &&
        <FilterDialog />
      }
    </>
  )
}
export default FilterButtonPeriodicalReport